"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateImageUrl = void 0;
const __1 = require("..");
const validators_1 = require("../GS/validators");
function validateImageUrl(value) {
    validators_1.validateString("imageUrl", value, { maxLength: 255, required: true });
    if (!validators_1.isUrl(value)) {
        throw new __1.ValidationError("imageUrl", "Image URL is invalid.");
    }
}
exports.validateImageUrl = validateImageUrl;
//# sourceMappingURL=customer-vehicles.js.map